import React from "react";
import EmploymentsDataTable from "./EmploymentsDataTable";

class EmploymentsPage extends React.Component {
  render() {
    return (
      <div className="sub-content">
        <EmploymentsDataTable />
      </div>
    );
  }
}

export default EmploymentsPage;



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/members/member/employments/EmploymentsPage.js